import { ref, watch, getCurrentInstance } from 'vue';
import { includesEnterprise } from './index';

/**
 * 管理路由缓存的 keep-alive include 列表
 * @param {Object} options - 配置选项
 * @param {boolean} options.debug - 是否开启调试打印
 * @returns {Object} - 包含 keepAliveIncludes 响应式数组
 */
export function useKeepAliveInclude(options = {}) {
	const { debug = false } = options;

	const vm = getCurrentInstance();
	const keepAliveIncludes = ref(['DynamicHome']);

	// 调试打印函数
	const log = (...args) => {
		if (debug) {
			console.log('[KeepAliveInclude]', ...args);
		}
	};

	// 检查是否为体系内路由
	const isSystemRoute = route => {
		const { name } = route;
		return includesEnterprise.includes(name);
	};

	// 根据路由参数直接计算应该缓存的组件
	const computeIncludes = ({ params, name }) => {
		// 菜单页
		if (params.menuId) {
			log('menuId 页面，缓存命中 [DynamicHome, MenuFrame]');
			return ['DynamicHome', 'MenuFrame'];
		}

		// 组件页
		if (params.moduleId && params.subPath) {
			log('FrameSub 页面，缓存命中 [DynamicHome, MenuFrame, ComponentFrame, ComponentFrameSub]');
			return ['DynamicHome', 'MenuFrame', 'ComponentFrame', 'ComponentFrameSub'];
		}

		// 子组件页
		if (params.moduleId) {
			log('Frame 页面，缓存命中 [DynamicHome, MenuFrame, ComponentFrame]');
			return ['DynamicHome', 'MenuFrame', 'ComponentFrame'];
		}

		// 首页或其他情况
		log('首页，只缓存 [DynamicHome]');
		return ['DynamicHome'];
	};

	// 监听路由变化，只处理体系内路由
	watch(
		() => vm.proxy.$route.fullPath,
		() => {
			const route = vm.proxy.$route;

			// 只处理体系内的路由变化
			if (!isSystemRoute(route)) {
				log('跳过体系外路由:', route.name, route.fullPath);
				return;
			}

			const oldIncludes = [...keepAliveIncludes.value];
			const newIncludes = computeIncludes(route);

			log('路由变化:', {
				route: route.name,
				path: route.fullPath,
				params: route.params,
				oldIncludes,
				newIncludes
			});

			keepAliveIncludes.value = newIncludes;
		},
		{ immediate: true }
	);

	return {
		keepAliveIncludes
	};
}
